import React from 'react';

import styled from 'styled-components';

import { SHARE_MODAL_TABS } from './constants';
import SendTestEmailNotificationModal from './SendTestEmailNotificationModal';
import { getTabDataOrDefault, useShareViaEmailContext } from './ShareViaEmailContext';
import { STATUS } from '../../../constants';
import Button from '../../lib/Button';
import { useCommunityViewContext } from '../CommunityViewContext';

const Footer = styled.div<{ hasLeftButton: boolean }>`
  display: flex;
  justify-content: ${({ hasLeftButton }) => (hasLeftButton ? 'space-between' : 'flex-end')};
  align-items: center;
  border-top: 1px solid var(--line-gray);
  padding: 20px 30px;
`;

interface Props {
  showSendTestEmailButton: boolean;
}

const ShareViaEmailFooter = ({ showSendTestEmailButton }: Props) => {
  const { loading, activeTab, shareTabData, notificationsTabData, notificationType, handleClose, handleSend } =
    useShareViaEmailContext();
  const { community } = useCommunityViewContext();

  // Determine current emails and selectedUsers based on active tab
  const currentData =
    activeTab === SHARE_MODAL_TABS.SHARE ? shareTabData : getTabDataOrDefault(notificationsTabData?.[notificationType]);

  const disabled =
    !(
      (Boolean(currentData.emails?.length) || Boolean(currentData.selectedUsers?.length)) &&
      ((activeTab === SHARE_MODAL_TABS.SHARE && Boolean(currentData?.views?.length)) ||
        (activeTab === SHARE_MODAL_TABS.NOTIFICATION && Boolean(currentData?.selectedCompetitors?.length)))
    ) || loading === STATUS.LOADING;

  const [showSendTestEmailNotificationModal, setShowSendTestEmailNotificationModal] = React.useState<boolean>(false);

  return (
    <>
      <Footer hasLeftButton={showSendTestEmailButton}>
        {showSendTestEmailButton && (
          <Button
            onClick={() => setShowSendTestEmailNotificationModal(true)}
            style={{ width: 194, height: 40 }}
            disabled={activeTab === SHARE_MODAL_TABS.NOTIFICATION && !currentData?.selectedCompetitors?.length}
          >
            Send Test Email...
          </Button>
        )}
        <div>
          <Button
            type="primary"
            style={{ width: 120, height: 40, marginRight: 10 }}
            onClick={handleSend}
            loading={loading === STATUS.LOADING}
            disabled={disabled}
          >
            Send
          </Button>
          <Button onClick={handleClose} style={{ width: 120, height: 40 }} disabled={loading === STATUS.LOADING}>
            Cancel
          </Button>
        </div>
      </Footer>

      <SendTestEmailNotificationModal
        showModal={showSendTestEmailNotificationModal}
        onConfirm={() => setShowSendTestEmailNotificationModal(false)}
        onClose={() => setShowSendTestEmailNotificationModal(false)}
      />
    </>
  );
};

export default ShareViaEmailFooter;
